export default __webpack_public_path__ + "static/media/stereo_light.e8396dc4.png";